import LegalLayout from "./LegalLayout";
import SeoHead from "@/components/SeoHead";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Notice" updated="May 2, 2026">
      <SeoHead title="Privacy Notice" />
      <p>
        This Privacy Notice explains how <strong>Storeseoai Team</strong> ("we", "us", "our"), based
        in Nepal, collects and uses personal data when you use StoreSEO AI (the "Service"). We act
        as the <strong>data controller</strong> for personal data processed in connection with the
        Service.
      </p>

      <h2>1. Personal Data We Collect</h2>
      <ul>
        <li><strong>Account data:</strong> name, email address, password (hashed), and authentication identifiers.</li>
        <li><strong>Content data:</strong> product information, prompts, and generated outputs you create using the Service.</li>
        <li><strong>Support data:</strong> messages and attachments you send to our support team.</li>
        <li><strong>Usage and telemetry:</strong> generation counts, feature usage, log data, error reports.</li>
        <li><strong>Device and connection data:</strong> IP address, browser type, device identifiers, approximate location.</li>
      </ul>

      <h2>2. Why We Use Your Data</h2>
      <ul>
        <li><strong>Provide the Service</strong> - create your account, generate SEO content, store your history (legal basis: contract performance).</li>
        <li><strong>Customer support</strong> - respond to your questions (contract performance).</li>
        <li><strong>Security &amp; fraud prevention</strong> - detect abuse and protect the Service (legitimate interests).</li>
        <li><strong>Product improvement &amp; analytics</strong> - understand how the Service is used (legitimate interests).</li>
        <li><strong>Legal compliance</strong> - meet our legal obligations (legal obligation).</li>
        <li><strong>Marketing</strong> - only where you have opted in (consent).</li>
      </ul>

      <h2>3. Sharing Your Data</h2>
      <p>We share personal data only with:</p>
      <ul>
        <li><strong>Service providers / sub-processors</strong> - hosting, database, AI model providers, analytics, and support tooling that operate the Service on our behalf.</li>
        <li><strong>Paddle.com</strong>, our Merchant of Record, for the sale of products, subscription management, payments, tax compliance, and invoicing.</li>
        <li><strong>Professional advisers</strong> - legal, accounting, and similar advisers when needed.</li>
        <li><strong>Authorities</strong> - where required by law or to protect our rights.</li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>
        We keep your personal data only as long as needed to provide the Service and for legitimate
        business or legal purposes. Account and content data are retained while your account is
        active and for a reasonable period after closure, after which they are deleted or
        anonymised.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have rights to access, correct, delete, restrict, or
        port your personal data, and to object to or withdraw consent for certain processing. You
        may exercise these rights by contacting{" "}
        <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a>. You also have the right to
        lodge a complaint with your local data protection authority.
      </p>

      <h2>6. Security</h2>
      <p>
        We use appropriate technical and organisational measures to protect your data, including
        encryption in transit, access controls, and secure authentication. No system is perfectly
        secure, but we work to reduce risk.
      </p>

      <h2>7. Cookies</h2>
      <p>
        We use essential cookies required to operate the Service (e.g. authentication, session
        state). We may use limited analytics cookies to understand usage. You can manage cookie
        preferences via your browser settings.
      </p>

      <h2>8. International Transfers</h2>
      <p>
        Your data may be processed in countries outside of your own. Where required, we rely on
        appropriate safeguards (such as Standard Contractual Clauses or adequacy decisions) for
        cross-border transfers.
      </p>

      <h2>9. Changes</h2>
      <p>We may update this Privacy Notice from time to time. We will post the updated version with a new "Last updated" date.</p>

      <h2>10. Contact</h2>
      <p>
        For privacy questions or to exercise your rights, contact{" "}
        <a href="mailto:storeseoai@gmail.com">storeseoai@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
